<template>
<div class="columns my-0 is-fullheight">
    <div class="column is-narrow py-0">
    <div class="sidebar-page">
        <sidebar/>
    </div>
    </div>
    <div class="column container">
        <router-view/>
    </div>
</div>
</template>

<script>
import Sidebar from './Sidebar.vue'

export default {
  data() {
    return {
    }
  },
  components:{
      Sidebar
  }
};
</script>

<style lang="scss">
.is-fullheight{
    min-height: 100vh;
}
.menu-label{
    color: #82bc00;
}
.menu-list a {
    color: white;
}
.menu-list a:hover {
    background-color: #82bc00;
    color: white;
}
.menu-list a.is-active {
    background-color: #82bc00;
    color: white;
}
.p-1 {
  padding: 1em;
}
.sidebar-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    // min-height: 100vh;
    .sidebar-layout {
        display: flex;
        flex-direction: row;
        min-height: 100%;
        // min-height: 100vh;
    }
}
@media screen and (max-width: 1023px) {
    .b-sidebar {
        .sidebar-content {
            &.is-mini-mobile {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 1024px) {
    .b-sidebar {
        .sidebar-content {
            &.is-mini {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
.is-mini-expand {
    .menu-list a {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>